import {
  REQUEST_MAP_FUELING_POSITIONS,
  RESPONSE_MAP_FUELING_POSITIONS,
  REQUEST_MAP_FUELING_POSITIONS_FAILURE,
  CLEAR_MAP_FUELING_POSITIONS,
} from "../actions/mapFuelingPositionsActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  fuelingsCount: 0,
  fuelings: [],
};

const mapFuelingsPositionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MAP_FUELING_POSITIONS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_MAP_FUELING_POSITIONS:
      const { fuelings, count } = action.payload;

      return Object.assign({}, state, {
        dataState: states.READY,
        fuelings: fuelings,
        fuelingsCount: count,
        errors: [],
      });
    case REQUEST_MAP_FUELING_POSITIONS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_MAP_FUELING_POSITIONS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default mapFuelingsPositionsReducer;
